import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { NavBar } from './navbar'
import { ButtonGroup } from './button-group/'
import { FONTS } from '../../../constants'

export default class Tab extends React.Component {
  render() {
    const { isFetching, isEdit } = this.props

    return (
      <SearchDivStyle>
        <SetForm>
          { !isEdit && <NavBar { ...this.props } /> }
          { !isFetching && <ButtonGroup { ...this.props } /> }
        </SetForm>
      </SearchDivStyle>
    )
  }
}

Tab.propTypes = {
  isFetching: PropTypes.bool,
  isEdit: PropTypes.bool,
}
Tab.defaultProps = {
  isFetching: false,
  isEdit: false,
}

const SearchDivStyle = styled.div`
  background-color: #ffffff ;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  height: 50px ;
  width: 100%;
  @media (max-width: 575.98px) {
    background-color: #D44B49 ;
  }
  @media (max-width: 767.98px) {
    background-color: #D44B49 ;
  }
`
const SetForm = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab/index.js